import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';
import { LogoComponent } from '../../common/components/logo/logo.component';
import { CompanySwitcherComponent } from './company-switcher/company-switcher.component';
import { UserMenuComponent } from './user-menu/user-menu.component';

@Component({
  selector: 'app-header',
  imports: [
    LogoComponent,
    UserMenuComponent,
    RouterLink,
    CompanySwitcherComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly AppUrls = AppUrls;
}
